import React from "react";
import { Button } from "../../UIElements/Button";
import { Icon } from "../../UIElements/Icon";

const UsersError = ({ error, onRetry }) => {
  const getErrorMessage = () => {
    if (error?.message) {
      return error.message;
    }
    if (error?.status === 404) {
      return "Users endpoint not found";
    }
    if (error?.status === 403) {
      return "You do not have permission to view users";
    }
    if (error?.status >= 500) {
      return "Server error occurred while loading users";
    }
    return "An error occurred while loading users";
  };

  return (
    <div className="py-12 text-center" role="alert">
      <div className="bg-error-bg mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full">
        <Icon name="AlertCircle" className="text-error h-8 w-8" />
      </div>
      <h3 className="text-foreground mb-2 text-lg font-semibold">
        Error Loading Users
      </h3>
      <p className="text-muted-foreground mx-auto mb-6 max-w-md">
        {getErrorMessage()}
      </p>
      {onRetry && (
        <Button
          type="button"
          onClick={onRetry}
          emphasis="outline"
          intent="neutral"
          size="touch"
        >
          <Icon name="RefreshCw" className="h-4 w-4" />
          Try Again
        </Button>
      )}
    </div>
  );
};

export default UsersError;
